import { useCallback } from 'react';
import { FormDropdownInputComponent } from 'src/features/generalForms/builder/types/DropdownInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormDropDownInput: FormDropdownInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (v: string) =>
      props.options
        ?.filter((opt) => opt.key === v)
        .map((opt) => opt.value)
        .join(', ') ?? '',
    [props.options],
  );

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return <AnswerPreviewRow<string> value={value} renderValue={renderValue} {...props} />;
};
